import React from 'react';
import { createTheme, Container, Box, Typography, Button, Grid, Card, CardContent, CardHeader, List, ListItem, ListItemIcon, ListItemText, Paper, Link } from '@mui/material';
import { useTheme, styled } from '@mui/material/styles';
import { Localized } from '@fluent/react';
import { Link as RLink, useNavigate } from "react-router-dom";
import { useRecoilValue } from 'recoil';
// Импорт иконок
import TelegramIcon from '@mui/icons-material/Telegram';
import PaymentIcon from '@mui/icons-material/Payment';
import SecurityIcon from '@mui/icons-material/Security';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import BlockIcon from '@mui/icons-material/Block';
import SyncProblemIcon from '@mui/icons-material/SyncProblem';
import VpnLockIcon from '@mui/icons-material/VpnLock';
import StorefrontIcon from '@mui/icons-material/Storefront';
import FlightTakeoffIcon from '@mui/icons-material/FlightTakeoff';
import AccountBalanceWalletIcon from '@mui/icons-material/AccountBalanceWallet';
import TrendingUpIcon from '@mui/icons-material/TrendingUp';
import LockClockIcon from '@mui/icons-material/LockClock';
// components
import { trafficSourceState } from '../state';
import { getTelegramBotLink } from '../utils/trafficSource';
import { FAQ } from '../components/FAQ';

import cardTransp from '../assets/card_transparent_opt.png';



// Стилизованный контейнер для секций
const SectionContainer = styled(Container)(({ theme }) => ({
  paddingTop: theme.spacing(10),
  paddingBottom: theme.spacing(10),
}));

// --- КОМПОНЕНТЫ СЕКЦИЙ ---

// 1. Первый экран (Hero Section)
const HeroSection = () => {
  const trafficSource = useRecoilValue(trafficSourceState);
  const telegramBotLink = getTelegramBotLink(trafficSource);

  return (
    <Box sx={{
      minHeight: 'calc(100vh - 64px)',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      textAlign: 'center',
      backgroundSize: 'cover',
      backgroundPosition: 'center',
      padding: { xs: 1, sm: 2, md: 4 },
      overflow: 'hidden',
    }}>
      <Container maxWidth="md" sx={{ mb: '10vh' }}>
        <Box
          component="img"
          sx={{
            width: { xs: '90%', sm: '100%' },
          }}
          alt="Stability illustration"
          src={cardTransp}
        />
        <Typography
          variant="h2"
          component="h1"
          gutterBottom
          sx={{
          // fontSize: { xs: '2.1rem', },
        }}>
          <Localized id="hero_title" />
        </Typography>
        <Typography variant="subtitle1"  sx={{
          mb: { xs: 2, sm: 4 },
          // fontSize: { xs: '1.1rem', },
        }}>
          <Localized id="hero_subtitle" />
        </Typography>
        <Button
          variant="outlined"
          color="secondary"
          size="large"
          endIcon={<TelegramIcon sx={{ fontSize: '2rem !important' }} />}
          href={telegramBotLink}
          sx={{
            borderRadius: '30px',
            fontSize: '1.4rem',
          }}
        >
          <Localized id="hero_button" />
        </Button>
      </Container>
    </Box>
  );
};

// 2. Блок "Проблема"
const ProblemSection = () => {
  const theme = useTheme();

  const problems = [
    {
      icon: <BlockIcon fontSize="large" color="error" />,
      textId: 'problem_item_1'
    },
    {
      icon: <SyncProblemIcon fontSize="large" color="error" />,
      textId: 'problem_item_2'
    },
    {
      icon: <VpnLockIcon fontSize="large" color="error" />,
      textId: 'problem_item_3'
    },
  ];

  return (
    <Box sx={{ bgcolor: 'rgba(0, 0, 0, 0.1)' }}>
      <SectionContainer maxWidth="lg">
        <Typography variant="h3" align="center" gutterBottom>
          <Localized id="problem_title" />
        </Typography>
        <Typography variant="subtitle1" align="center" sx={{ mb: 6 }}>
          <Localized id="problem_subtitle" />
        </Typography>
        <Grid container spacing={4}>
          {problems.map((item, index) => (
            <Grid item xs={12} md={4} key={index}>
              <Box sx={{
                p: 4,
                backdropFilter: 'blur(7px)',
                boxShadow: '0px 1px 10px 0px #00000055',
                backgroundColor: 'rgba(0, 0, 0, 0.3)',
                textAlign: 'center', height: '100%'
              }}>
                <Box sx={{ mb: 2 }}>{item.icon}</Box>
                <Typography variant="h6">
                  <Localized id={item.textId} />
                </Typography>
              </Box>
            </Grid>
          ))}
        </Grid>
        <Typography variant="h5" align="center" sx={{ mt: 6, fontWeight: 'bold' }}>
          <Localized id="problem_conclusion" />
          <br />
          <span style={{ color: theme.palette.primary.main }}>
            <Localized id="problem_conclusion_highlight" />
          </span>
        </Typography>
      </SectionContainer>
    </Box>
  );
};

// 3. Блок "Сценарии использования"
const UseCasesSection = () => {
  const useCases = [
    {
      icon: <PaymentIcon color="primary" sx={{ fontSize: 40 }} />,
      titleId: 'usecases_payment_title',
      descriptionId: 'usecases_payment_desc'
    },
    {
      icon: <FlightTakeoffIcon color="primary" sx={{ fontSize: 40 }} />,
      titleId: 'usecases_travel_title',
      descriptionId: 'usecases_travel_desc'
    },
    {
      icon: <StorefrontIcon color="primary" sx={{ fontSize: 40 }} />,
      titleId: 'usecases_ads_title',
      descriptionId: 'usecases_ads_desc'
    },
  ];
  // bgcolor: 'background.paper'
  return (
    <Box sx={{
      // bgcolor: 'rgba(0, 0, 0, 0.1)'
    }}>
      <SectionContainer maxWidth="lg">
        <Typography variant="h3" align="center" gutterBottom>
          <Localized id="usecases_title" />
        </Typography>
        <Grid container spacing={4} sx={{ mt: 4 }}>
          {useCases.map((item, index) => (
            <Grid item xs={12} md={4} key={index}>
              <Card sx={{
                height: '100%', p: 2,
                backdropFilter: 'blur(7px)',
                boxShadow: '0px 1px 10px 0px #00000055',
                backgroundColor: 'rgba(0, 0, 0, 0.3)',
              }}>
                <CardContent>
                  <Box sx={{ mb: 2 }}>{item.icon}</Box>
                  <Typography variant="h5" component="h3" gutterBottom>
                    <Localized id={item.titleId} />
                  </Typography>
                  <Typography variant="body1" color="text.secondary" textAlign={'center'}>
                    <Localized id={item.descriptionId} />
                  </Typography>
                </CardContent>
              </Card>
            </Grid>
          ))}
        </Grid>
      </SectionContainer>
    </Box>
  );
};

// 4. Блок "Стабильность сбережений"
const StabilitySection = () => (
  <Box sx={{
    bgcolor: 'rgba(0, 0, 0, 0.1)'
  }}>
    <SectionContainer maxWidth="lg">
      <Typography variant="h3" align="center" gutterBottom>
        <Localized id="stability_title" />
      </Typography>
      <Typography variant="subtitle1" align="center" sx={{ mb: 6 }}>
        <Localized id="stability_subtitle" />
      </Typography>
      <Grid container alignItems="center">
        <Grid item container xs={12} md={6}>
          <ListItem>
            <ListItemIcon><TrendingUpIcon color="primary" /></ListItemIcon>
            <ListItemText
              primary={<Localized id="stability_reliability_title" />}
              secondary={<Localized id="stability_reliability_desc" />}
            />
          </ListItem>
        </Grid>
        <Grid item container xs={12} md={6}>
          <ListItem>
            <ListItemIcon><SecurityIcon color="primary" /></ListItemIcon>
            <ListItemText
              primary={<Localized id="stability_security_title" />}
              secondary={<Localized id="stability_security_desc" />}
            />
          </ListItem>
        </Grid>
        <Grid item container xs={12} md={6}>
          <ListItem>
            <ListItemIcon><AccountBalanceWalletIcon color="primary" /></ListItemIcon>
            <ListItemText
              primary={<Localized id="stability_access_title" />}
              secondary={<Localized id="stability_access_desc" />}
            />
          </ListItem>
        </Grid>
        <Grid item container xs={12} md={6}>
          <ListItem>
            <ListItemIcon><LockClockIcon color="primary" /></ListItemIcon>
            <ListItemText
              primary={<Localized id="stability_predictability_title" />}
              secondary={<Localized id="stability_predictability_desc" />}
            />
          </ListItem>
        </Grid>
      </Grid>
    </SectionContainer>
  </Box >
);

// 5. Блок "Тарифы"
const PricingSection = () => {
  const trafficSource = useRecoilValue(trafficSourceState);
  const telegramBotLink = getTelegramBotLink(trafficSource);

  const plans = [
    {
      titleId: 'pricing_start_title',
      priceId: 'pricing_start_price',
      features: [
        'pricing_start_fee',
        'pricing_start_no_tx_fee',
        'pricing_start_small_expenses',
        'pricing_start_basic_support'
      ]
    },
    {
      titleId: 'pricing_balance_title',
      priceId: 'pricing_balance_price',
      features: [
        'pricing_balance_fee',
        'pricing_balance_no_tx_fee',
        'pricing_balance_optimal',
        'pricing_balance_priority_support'
      ]
    },
    {
      titleId: 'pricing_premium_title',
      priceId: 'pricing_premium_price',
      popular: true,
      popularTextId: 'pricing_popular',
      features: [
        'pricing_premium_fee',
        'pricing_premium_no_tx_fee',
        'pricing_premium_large_payments',
        'pricing_premium_priority_support'
      ]
    },
  ];

  // bgcolor: 'background.paper'
  return (
    <Box sx={{
      // bgcolor: 'rgba(0, 0, 0, 0.1)'
    }} id="pricing">
      <SectionContainer maxWidth="lg">
        <Typography variant="h3" align="center" gutterBottom>
          <Localized id="pricing_title" />
        </Typography>
        <Typography variant="subtitle1" align="center" sx={{ mb: 6 }}>
          <Localized id="pricing_subtitle" />
        </Typography>
        <Grid container spacing={4} alignItems="flex-end">
          {plans.map((plan, index) => (
            <Grid item key={index} xs={12} md={4}>
              <Card sx={{
                border: plan.popular ? `2px solid #0a87fb55` : 'none',
                backdropFilter: 'blur(7px)',
                boxShadow: '0px 1px 10px 0px #00000055',
                backgroundColor: 'rgba(0, 0, 0, 0.1)',
              }}>

                <CardHeader
                  title={<Localized id={plan.titleId} />}
                  subheader={plan.popular ? <Localized id={plan.popularTextId} /> : null}
                  titleTypographyProps={{ align: 'center', variant: 'h4' }}
                  subheaderTypographyProps={{ align: 'center', color: 'primary' }}
                  sx={{
                    // backdropFilter: 'blur(1px)',
                    // boxShadow: '0px 1px 10px 0px #00000055',
                    backgroundColor: 'rgba(255, 255, 255, 0.01)',
                  }}
                />

                <CardContent sx={{
                  backdropFilter: 'blur(7px)',
                  boxShadow: '0px 1px 10px 0px #00000055',
                  backgroundColor: 'rgba(0, 0, 0, 0.00)',
                }}>
                  <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'baseline', mb: 2 }}>
                    <Typography component="h2" variant="h3" color="text.primary">
                      <Localized id={plan.priceId} />
                    </Typography>
                  </Box>
                  <Typography variant="caption" align="center" display="block">
                    <Localized id="pricing_one_time_fee" />
                  </Typography>
                  <List>
                    {plan.features.map((featureId) => (
                      <ListItem key={featureId} disableGutters>
                        <ListItemIcon sx={{ minWidth: '32px' }}><CheckCircleOutlineIcon fontSize="small" color="primary" /></ListItemIcon>
                        <ListItemText primary={<Localized id={featureId} />} />
                      </ListItem>
                    ))}
                  </List>
                </CardContent>

                {/* <Box sx={{
                  p: 2,
                  backdropFilter: 'blur(7px)',
                  boxShadow: '0px 1px 10px 0px #00000055',
                  backgroundColor: 'rgba(0, 0, 0, 0.00)',
                }}>
                  <Button
                    component={RLink}
                    fullWidth
                    variant={plan.popular ? 'contained' : 'outlined'}
                    to={telegramBotLink}
                    href={telegramBotLink}
                    target='_blank'
                    rel='noopener noreferrer'
                  >
                    <Localized id="pricing_select_button" />
                  </Button>
                </Box> */}
              </Card>
            </Grid>
          ))}
        </Grid>
        <Typography variant="body2" align="center" sx={{ mt: 4, color: 'text.secondary' }}>
          <Localized id="pricing_footer_note" />
        </Typography>
      </SectionContainer>
    </Box>
  );
};

// 6. FAQ
const FAQSection = () => (
  <Box sx={{ bgcolor: 'rgba(0, 0, 0, 0.1)' }} id="faq">
    <SectionContainer maxWidth="md" sx={{ textAlign: 'center' }}>
      <FAQ />
    </SectionContainer>
  </Box>
);

// 7. Финальный призыв к действию
const FinalCTASection = () => {
  const trafficSource = useRecoilValue(trafficSourceState);
  const telegramBotLink = getTelegramBotLink(trafficSource);

  return (
    <SectionContainer maxWidth="md" sx={{ textAlign: 'center' }}>
      <Typography variant="h3" component="h2" gutterBottom>
        <Localized id="final_cta_title" />
      </Typography>
      <Typography variant="subtitle1" sx={{ mb: 4 }}>
        <Localized id="final_cta_subtitle" />
      </Typography>
      <Button
        variant="outlined"
        color="secondary"
        size="large"
        endIcon={<TelegramIcon sx={{ fontSize: '2rem !important' }} />}
        href={telegramBotLink}
        sx={{
          borderRadius: '30px',
          fontSize: '1.4rem',
        }}
      >
        <Localized id="final_cta_button" />
      </Button>
    </SectionContainer>
  );
};


export default function App() {
  return (
    <>
      <main>
        <HeroSection />
        <ProblemSection />
        <UseCasesSection />
        <StabilitySection />
        <PricingSection />
        <FAQSection />
        <FinalCTASection />
      </main>
    </>
  );
}
